import { SVGProps, Ref, forwardRef, useId } from 'react';

export const EmojiSad3dSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => {
    const _uniqueId = useId();
    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g filter={`url(#${_uniqueId}filter0_i_8745_19)`} suppressHydrationWarning>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 1C2.375 1 1 2.375 1 12s1.375 11 11 11 11-1.375 11-11S21.625 1 12 1M9.456 17.446c-.368.392-.556.843-.556 1.304H7.1c0-.98.407-1.858 1.044-2.536.917-.977 2.326-1.564 3.856-1.564s2.939.586 3.856 1.564c.637.678 1.044 1.556 1.044 2.536h-1.8c0-.46-.188-.912-.556-1.304-.542-.577-1.457-.996-2.544-.996-1.088 0-2.002.419-2.544.996M17.5 10.4h-4V8.6h4zm-11 0h4V8.6h-4z"
                    fill={`url(#${_uniqueId}paint0_radial_8745_19)`}
                    suppressHydrationWarning
                />
                <path
                    d="M10.5 10.4h-4V8.6h4z"
                    fill={`url(#${_uniqueId}paint1_radial_8745_19)`}
                    suppressHydrationWarning
                />
                <path
                    d="M13.5 10.4h4V8.6h-4z"
                    fill={`url(#${_uniqueId}paint2_radial_8745_19)`}
                    suppressHydrationWarning
                />
                <path
                    d="M8.9 18.75c0-.46.188-.912.556-1.304.542-.577 1.457-.996 2.544-.996 1.088 0 2.002.419 2.544.996.368.392.556.843.556 1.304h1.8c0-.98-.407-1.858-1.044-2.536-.917-.977-2.326-1.564-3.856-1.564s-2.939.586-3.856 1.564C7.507 16.892 7.1 17.77 7.1 18.75z"
                    fill={`url(#${_uniqueId}paint3_radial_8745_19)`}
                    suppressHydrationWarning
                />
            </g>
            <path d="M10.5 10.4h-4V8.6h4z" fill="#79610C" />
            <path d="M13.5 10.4h4V8.6h-4z" fill="#79610C" />
            <path
                d="M8.9 18.75c0-.46.188-.912.556-1.304.542-.577 1.457-.996 2.544-.996 1.088 0 2.002.419 2.544.996.368.392.556.843.556 1.304h1.8c0-.98-.407-1.858-1.044-2.536-.917-.977-2.326-1.564-3.856-1.564s-2.939.586-3.856 1.564C7.507 16.892 7.1 17.77 7.1 18.75z"
                fill="#79610C"
            />
            <defs>
                <filter
                    id={`${_uniqueId}filter0_i_8745_19`}
                    x={1}
                    y={-2.75}
                    width={25.75}
                    height={25.75}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                    suppressHydrationWarning
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx={3.75} dy={-3.75} />
                    <feGaussianBlur stdDeviation={3.75} />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_8745_19" />
                </filter>
                <radialGradient
                    id={`${_uniqueId}paint0_radial_8745_19`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(7.29056 5.125) rotate(52.125) scale(19.5968)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
                <radialGradient
                    id={`${_uniqueId}paint1_radial_8745_19`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(7.29056 5.125) rotate(52.125) scale(19.5968)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
                <radialGradient
                    id={`${_uniqueId}paint2_radial_8745_19`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(7.29056 5.125) rotate(52.125) scale(19.5968)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
                <radialGradient
                    id={`${_uniqueId}paint3_radial_8745_19`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(7.29056 5.125) rotate(52.125) scale(19.5968)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
            </defs>
        </svg>
    );
});
EmojiSad3dSize24Glyph.displayName = 'EmojiSad3dSize24Glyph';
